<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.sector-modal.chose-sector') }}
            </h3>
        </template>

        <template #default>
            <p>
                {{ $t('global.sector-modal.label') }}
            </p>
            <v-divider></v-divider>
            <v-row justify="center" class="">
                <v-col class="px-2" sm="12" lg="6">
                    <v-select v-model="firstProductCategory" variant="outlined" density="compact" :hide-details="true"
                        :items="productCategories" :no-data-text="$t('global.sector-modal.empty')">
                        <template v-slot:selection="{ item }">
                            {{ item.value.translations[selectedLanguage.toUpperCase()].value }}
                        </template>
                        <template v-slot:item="{ item, props }">
                            <v-list-item v-bind="props">
                                <template #title>
                                    <span>{{ item.value.translations[selectedLanguage.toUpperCase()].value }}</span>
                                </template>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
                <v-col class="px-2" sm="12" lg="6">
                    <v-select v-model="secondProductCategory" variant="outlined" density="compact" :hide-details="true"
                        :items="productCategories" :no-data-text="$t('global.sector-modal.empty')" :clearable="true">
                        <template v-slot:selection="{ item }">
                            {{ item.value.translations[selectedLanguage.toUpperCase()].value }}
                        </template>
                        <template v-slot:item="{ item, props }">
                            <v-list-item v-bind="props">
                                <template #title>
                                    <span>{{ item.value.translations[selectedLanguage.toUpperCase()].value }}</span>
                                </template>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="() => handleSubmit()">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import { inject } from 'vue'
export default {
    name: "EditShopCategoryDialog",
    methods: {

    },
};
</script>
<script setup>
import { ref, watch, computed, defineProps, defineEmits } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");
const productCategories = inject('productCategories', []);
const originalShop = inject('shop');
// const  = ref(Object.assign({}, orignalShop.value));
const shop = ref({ ...originalShop.value });
const firstProductCategory = ref(null);
const secondProductCategory = ref(null);
const selectedLanguage = localStorage.getItem('selectedLanguage');
// firstProductCategory.value = Object.values(shop.value.productCategories);

watch(() => originalShop.value, (newShop) => {
    if (!newShop) return; 
    shop.value = { ...newShop }; // Create a fresh copy when the original shop changes

    firstProductCategory.value = newShop.productCategories?.[0] || null;
    secondProductCategory.value = newShop.productCategories?.[1] || null;
}, { deep: true, immediate: true });

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    save:{
        type:Function,
        required:true
    }
});



// Call parent method
const handleSubmit = () => {
  emit('submitProfile',[firstProductCategory.value,secondProductCategory.value]);
};


const emit = defineEmits(['update:modelValue','submitProfile'])

const show = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const closeSheet = () => {
    show.value = false;
    firstProductCategory.value = shop.value.productCategories[0] || null;
    secondProductCategory.value = shop.value.productCategories[1] || null;
}


 
</script>
<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}
</style>
